import axios from '../../../axios';
import FeeArrangementDTO from '../types/FeeArrangementDTO';

const url = 'invoicingservice/api/arrangement';

export const getWithIdAsValueIfMissing = (obj: any) => ({ id: obj.value, ...obj });

export const getArrangementsPage = (
  page: number,
  size: number,
  clientId: string,
  sortBy?: string,
  sortOrder?: string | null
) => {
  const params = new URLSearchParams({
    page: page.toString(),
    size: size.toString(),
    clientId,
  });
  return axios.get(`${url}?${params.toString()}&sortBy=${sortBy}&sortOrder=${sortOrder}`);
};

export const createNewFeeArrangement = (arrangement: FeeArrangementDTO) =>
  axios.post(url, arrangement);

export const getFeeArrangementById = (id: string) => axios.get(`${url}/${id}`);

export const updateFeeArrangement = (arrangement: FeeArrangementDTO) => axios.put(url, arrangement);

export const getAllFeeArrangementsForClient = (clientId: string) =>
  axios.get(`${url}/list/client/${clientId}`);
